import React from "react";
import { Star, Users, Calendar, MessageCircle, Video, FileText } from "lucide-react";

const Sidebar = () => {
  const myMentors = [
    { name: "Sarah Chen", title: "AI Product Manager", rating: 4.9, id: "1" },
    { name: "David Rodriguez", title: "Cloud Architect", rating: 4.8, id: "2" }
  ];

  const upcomingAppointments = [
    {
      title: "Career Strategy Session",
      mentor: "Sarah Chen",
      time: "2:00 PM - 3:00 PM",
      date: "Today",
      type: "session"
    },
    {
      title: "Cloud Computing Q&A",
      mentor: "David Rodriguez", 
      time: "10:00 AM - 11:00 AM",
      date: "Tomorrow",
      type: "qa"
    }
  ];

  return (
    <div className="w-80 space-y-6">
      {/* My Mentors Section */}
      <div className="bg-gray-50 border border-gray-300 rounded-xl p-4 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="rounded-lg flex items-center justify-center">
            <Users className="w-5 h-5 text-purple-600" />
          </div>
          <h3 className="text-lg font-bold text-gray-900">My Mentors</h3>
        </div>

        <div className="space-y-3 mb-4">
          {myMentors.map((mentor) => (
            <div key={mentor.id} className="flex items-center justify-between border border-gray-300 p-3 bg-gray-50 rounded-lg">
              <div>
                <p className="font-medium text-sm text-gray-900">{mentor.name}</p>
                <p className="text-xs text-gray-600">{mentor.title}</p>
                <div className="flex items-center gap-1 mt-1">
                  <Star className="w-3 h-3 text-yellow-400 fill-current" />
                  <span className="text-xs text-gray-600">{mentor.rating}</span>
                </div>
              </div>
              <button className="flex items-center gap-2 px-3 py-1.5 bg-purple-100 text-purple-700 text-sm font-medium rounded-lg hover:bg-purple-200 transition-colors">
                <MessageCircle className="w-3 h-3" />
                Chat
              </button>
            </div>
          ))}
        </div>

        <button className="w-full py-1 px-1 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors">
          Find More Mentors
        </button>
      </div>

      {/* Upcoming Appointments Section */}
      <div className="bg-gray-50 border border-gray-300 rounded-xl p-6 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="rounded-lg flex items-center justify-center">
            <Calendar className="w-5 h-5 text-purple-600" />
          </div>
          <h3 className="text-lg font-bold text-gray-900">Upcoming Appointments</h3>
        </div>

        <div className="space-y-3 mb-4">
          {upcomingAppointments.map((appointment, index) => (
            <div key={index} className="p-2 border border-gray-300 bg-gray-50 rounded-lg">
              <div className="flex items-start justify-between">
                <h4 className="font-medium text-gray-900 text-sm">{appointment.title}</h4>
                <span className="px-2 py-1 bg-gray-200 text-gray-600 text-xs rounded-full">
                  {appointment.date}
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-1">
                with {appointment.mentor}
              </p>
              <p className="text-sm text-gray-600 mb-2">
                {appointment.time}
              </p>
              <div className="flex gap-2">
                {appointment.type === "session" ? (
                  <button className="flex items-center gap-1 px-3 py-1.5 bg-purple-600 text-white text-xs font-medium rounded-lg hover:bg-purple-700 transition-colors">
                    <Video className="w-3 h-3" />
                    Join
                  </button>
                ) : (
                  <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-300 text-gray-700 text-xs font-medium rounded-lg hover:bg-gray-50 transition-colors">
                    <FileText className="w-3 h-3" />
                    Prepare
                  </button>
                )}
                <button className="flex items-center gap-1 px-3 py-1.5 bg-white border border-gray-300 text-gray-700 text-xs font-medium rounded-lg hover:bg-gray-50 transition-colors">
                  <Calendar className="w-3 h-3" />
                  Reschedule
                </button>
              </div>
            </div>
          ))}
        </div>

        <p className="text-sm text-gray-500 text-center mb-4">No more appointments this week.</p>

        <button className="w-full py-1 px-1 border border-gray-300 text-gray-600 font-medium rounded-lg hover:bg-gray-200 transition-colors">
          Book New Session
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 